module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-dusty-rose-1-030f024c91e68623609f99fa9084f6fa.webp";